import { noop } from 'lodash-es'

const devLogger =
  process.env.NEXT_PUBLIC_APP_ENV === 'development'
    ? {
        debug: globalThis.console.debug.bind(
          globalThis.console,
          '[DEV only]: %s',
        ),
        log: globalThis.console.log.bind(globalThis.console, '[DEV only]: %s'),
        info: globalThis.console.info.bind(
          globalThis.console,
          '[DEV only]: %s',
        ),
        warn: globalThis.console.warn.bind(
          globalThis.console,
          '[DEV only]: %s',
        ),
        error: globalThis.console.error.bind(
          globalThis.console,
          '[DEV only]: %s',
        ),
      }
    : {
        debug: noop,
        log: noop,
        info: noop,
        warn: noop,
        error: noop,
      }

export const logger = {
  log: globalThis.console.log.bind(globalThis.console),
  info: globalThis.console.info.bind(globalThis.console),
  debug: globalThis.console.debug.bind(globalThis.console),
  warn: globalThis.console.warn.bind(globalThis.console),
  error: globalThis.console.error.bind(globalThis.console),
  /** 仅开发环境打印的日志器 */
  dev: devLogger,
}
